package com.evoapps.evoshift.domain.usecase.user

import com.evoapps.evoshift.domain.repository.UserRepository

class TerminateEngagementUseCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(userId: String, workplaceId: String): Result<Unit> {
        // Tu można dodać logikę sprawdzania uprawnień (np. czy Manager zwalnia pracownika SWOJEGO lokalu),
        // ale zakładając, że to już obsłużone wyżej/w UI:

        return userRepository.terminateEngagement(userId, workplaceId)
    }
}